// src/utils/auth.js

// Decodes the payload of a JWT without verifying the signature.
// Safe for client-side use since it's only reading a claim we already trust
// (the server issued it and every protected API call re-validates it).
export const getUserIdFromToken = () => {
  const token = localStorage.getItem('authToken');
  if (!token) return null;
  try {
    const raw = token.startsWith('Bearer ') ? token.slice(7) : token;
    const payloadBase64 = raw.split('.')[1];
    const payloadJson = atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'));
    const payload = JSON.parse(payloadJson);
    return payload.userId || null;
  } catch (e) {
    console.error('Failed to decode auth token:', e);
    return null;
  }
};